/** Shared by the Next API fallback and the small production gateway. */
export function normalizeVisitorCountry(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const country = value.trim().toUpperCase();
  return /^[A-Z]{2}$/.test(country) && country !== "XX" ? country : null;
}
